export const MODAL_KEYS = {
  DAYS_TO_BREACH_AGREEMENT: 'DAYS_TO_BREACH_AGREEMENT',
  UNDERSTAND_YOUR_BILLS: 'UNDERSTAND_YOUR_BILLS',
  FILE_UPLOAD: 'FILE_UPLOAD',
  PASSWORD_RESET: 'PASSWORD_RESET',
  PAYMENT: 'PAYMENT',
  PIX_PAYMENT: 'PIX_PAYMENT',
  CREDIT_CARD: 'CREDIT_CARD',
  UPDATE_EMAIL: 'UPDATE_EMAIL',
  MESSAGES: 'MESSAGES',
  URA_EVALUATION_SUCESS: 'URA_EVALUATION_SUCESS',
  URA_EVALUATION_VALIDATION: 'URA_EVALUATION_VALIDATION',
  CONTACT_UPDATE: 'CONTACT_UPDATE',
  REFER_FRIEND: 'REFER_FRIEND',
  OBJECTIONS: 'OBJECTIONS',
  REDIRECT_LINK: 'REDIRECT_LINK',
  REQUIRED_PASSWORD_UPDATE: 'REQUIRED_PASSWORD_UPDATE',
  NONE: '',
}

export const MODAL_CUSTOM_CLASS = {
  refer_friend: MODAL_KEYS.REFER_FRIEND,
  contact_update: MODAL_KEYS.CONTACT_UPDATE,
}
